import React from 'react';
import {usePages} from 'helpers';
import {Button} from 'components';

export function Next({children, ...props}) {
  const {next} = usePages();
  return Boolean(next) && (
    <Button to={next} {...props} >
      { children || 'Next' }
    </Button>
  );
}
